/**
 * 监测跟踪线索总路由
 * 2019-06-18
 * Qian.qianchen
 */
"use strict";
angular.module("tracingMonitoringRouterModule", []).config(["$stateProvider",
    function($stateProvider) {
        $stateProvider.
        state("front.plan.realtimeclues.plannedclues.tracingmonitoring", {
            url: '/tracingmonitoring?trackid&trackname', //监测跟踪
            views: {
                "main@front.plan.realtimeclues.plannedclues": {
                    templateUrl: "./planningCenter/realTimeClues/plannedClues/tracingMonitoring/tracingMonitoring_tpl.html",
                    controller: "tracingMonitoringCtrl"
                }
            }
        }).
        state("front.plan.realtimeclues.plannedclues.docdetail", {
            url: '/docdetail?trackid&trackname&resoucetype&areaname&cloudword&areacode', //稿件列表
            views: {
                "main@front.plan.realtimeclues.plannedclues": {
                    templateUrl: "./planningCenter/realTimeClues/plannedClues/tracingMonitoring/docDetail/docDetail_tpl.html",
                    controller: "docDetailCtrl"
                }
            }
        }).
        state("front.plan.realtimeclues.plannedclues.picdetail", {
            url: '/picdetail?trackid&trackname&resoucetype', //图片列表
            views: {
                "main@front.plan.realtimeclues.plannedclues": {
                    templateUrl: "./planningCenter/realTimeClues/plannedClues/tracingMonitoring/picDetail/picDetail_tpl.html",
                    controller: "picDetailCtrl"
                }
            }
        });
    }
]);